/**
 * Core module exports - Centralized access to core functionality
 */
export { apiClient } from './api';
export { AuthProvider, ProtectedRoute } from './auth';
export { useAuth } from './hooks';
export { storage } from './utils';
